import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { CarRequestForm } from "@/components/CarRequestForm";

const STORAGE_KEY = "cwm_popup_seen";

export const PopupForm = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(STORAGE_KEY);
    if (!seen) {
      const t = setTimeout(() => setOpen(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const handleSuccess = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setTimeout(() => setOpen(false), 2500);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="contact-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={close}
          className="fixed inset-0 z-[100] flex items-start sm:items-center justify-center bg-black/80 backdrop-blur-sm p-4 overflow-y-auto"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            data-testid="contact-popup"
            className="relative w-full max-w-lg my-8 bg-white rounded-sm shadow-2xl p-6 sm:p-8"
          >
            <button
              onClick={close}
              data-testid="popup-close-btn"
              aria-label="Close"
              className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center rounded-sm text-gray-500 hover:text-[#0A0A0A] hover:bg-gray-100 transition-colors"
            >
              <X size={20} />
            </button>
            <CarRequestForm onSuccess={handleSuccess} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
